import React from "react";
import "../../styles/Blogs/BlogsPopularArticles.scss";
import { Col, Container, Row } from "react-bootstrap";
import SwiperSlider from "./SwiperSlider";
const BlogsPopularArticles = () => {
  return (
    <Container fluid className="blog-popular-article-container p-0">
      <Container>
        <Row>
          <Col md={6}>
            <h1 className="title">The Blog</h1>
            <p className="blog-description">
              Lorem Ipsum is <span className="mezro">MEZRO</span> of the
              printing and typesetting industry. Lorem Ipsum has been the
              industry's standard dummy text ever since the 1500s
            </p>
          </Col>
          <Col md={6}>
            <SwiperSlider />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default BlogsPopularArticles;
